import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import Spinner from "./Spinner";
import './InfiniteLoader.css';
const InfiniteLoader = ({ active = true, onActivation, rootMargin }) => {
    const ref = React.useRef(null);
    const [spinning, setSpinning] = React.useState(true);
    const [intersectionObserver, setIntersectionObserver] = React.useState(null);
    useEffect(() => {
        if (!ref.current)
            return;
        if (!active) {
            setSpinning(false);
            intersectionObserver === null || intersectionObserver === void 0 ? void 0 : intersectionObserver.disconnect();
            setIntersectionObserver(null);
            return;
        }
        const observer = new IntersectionObserver((entries) => {
            var _a;
            if (entries[0].intersectionRatio > 0) {
                setSpinning(true);
                observer.disconnect();
                if (active)
                    (_a = onActivation === null || onActivation === void 0 ? void 0 : onActivation()) === null || _a === void 0 ? void 0 : _a.then(finished);
            }
        }, { rootMargin });
        function finished() {
            setSpinning(false);
            if (ref.current && active) {
                observer.observe(ref.current);
            }
        }
        observer.observe(ref.current);
        setIntersectionObserver(observer);
        return () => {
            observer.disconnect();
            intersectionObserver === null || intersectionObserver === void 0 ? void 0 : intersectionObserver.disconnect();
            setIntersectionObserver(null);
        };
    }, [ref.current, active, onActivation, rootMargin]);
    return (_jsx("div", { ref: ref, className: `infiniteLoader ${active ? 'active' : 'inactive'} ${spinning ? 'spinning' : ''}`, children: _jsx(Spinner, { spinning: spinning }) }));
};
export default InfiniteLoader;
